/**
 * Persistentes Banner während einer Impersonation. In `__root` gemountet, also
 * auf jeder Seite sichtbar. Macht unmissverständlich klar, dass der Staff gerade
 * als jemand anderes agiert, und bietet den Ausstieg.
 */
import { useImpersonation } from '../hooks/useImpersonation.js';
import { Button } from './ui/button.js';

const ROLE_LABEL: Record<string, string> = {
  worker: 'Mitarbeiter',
  client: 'Kunde',
};

export function ImpersonationBanner() {
  const { impersonating, realUser, actingAs, stop, stopping } = useImpersonation();
  if (!impersonating) return null;

  const targetName = actingAs?.name?.trim() || 'Unbekannt';
  const targetRole = actingAs?.role ? (ROLE_LABEL[actingAs.role] ?? actingAs.role) : null;

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-2 border-b border-[oklch(0.6_0.2_25)] bg-[oklch(0.55_0.2_25)] px-4 py-2 text-sm text-[oklch(0.98_0_0)]"
    >
      <span>
        ⚠️ Du agierst als <strong>{targetName}</strong>
        {targetRole ? ` (${targetRole})` : ''}
        {realUser?.name ? (
          <>
            {' '}
            — angemeldet als <strong>{realUser.name}</strong>
          </>
        ) : null}
      </span>
      <Button
        size="sm"
        variant="outline"
        onClick={() => stop()}
        disabled={stopping}
        className="border-[oklch(0.98_0_0)] text-[oklch(0.98_0_0)] hover:bg-[oklch(0.6_0.2_25)] hover:text-[oklch(0.98_0_0)]"
      >
        {stopping ? 'Beende …' : 'Impersonation beenden'}
      </Button>
    </div>
  );
}
